const isDateBefore = (date1: Date, date2: Date): boolean => {
    const strippedDate1 = new Date(
        date1.getFullYear(),
        date1.getMonth(),
        date1.getDate()
    );
    const strippedDate2 = new Date(
        date2.getFullYear(),
        date2.getMonth(),
        date2.getDate()
    );
    return strippedDate1 < strippedDate2;
};

const isDateBeforeOrEqual = (date1: Date, date2: Date): boolean => {
    const strippedDate1 = new Date(
        date1.getFullYear(),
        date1.getMonth(),
        date1.getDate()
    );
    const strippedDate2 = new Date(
        date2.getFullYear(),
        date2.getMonth(),
        date2.getDate()
    );
    return strippedDate1 <= strippedDate2;
};

const isDateAfter = (date1: Date, date2: Date): boolean => {
    const strippedDate1 = new Date(
        date1.getFullYear(),
        date1.getMonth(),
        date1.getDate()
    );
    const strippedDate2 = new Date(
        date2.getFullYear(),
        date2.getMonth(),
        date2.getDate()
    );
    return strippedDate1 > strippedDate2;
};

const isDateAfterOrEqual = (date1: Date, date2: Date): boolean => {
    const strippedDate1 = new Date(
        date1.getFullYear(),
        date1.getMonth(),
        date1.getDate()
    );
    const strippedDate2 = new Date(
        date2.getFullYear(),
        date2.getMonth(),
        date2.getDate()
    );
    return strippedDate1 >= strippedDate2;
};

const getStringFromDate = (date: Date): string => {
    const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
    const month =
        date.getMonth() + 1 < 10
            ? `0${date.getMonth() + 1}`
            : date.getMonth() + 1;
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
};

const formatStringToBrazilianFormat = (date: string): string => {
    const dateArray = date.split("-");
    return `${dateArray[2]}/${dateArray[1]}/${dateArray[0]}`;
};

const formatDateToString = (date: Date): string => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
};

const diffenceBetweenDatesInMinutes = (
    startDate: Date,
    endDate: Date
): number => (endDate.getTime() - startDate.getTime()) / (1000 * 60);

export default {
    isDateBefore,
    isDateAfter,
    isDateAfterOrEqual,
    isDateBeforeOrEqual,
    getStringFromDate,
    formatStringToBrazilianFormat,
    diffenceBetweenDatesInMinutes,
    formatDateToString,
};
